import React from 'react'
import { Link as ReactRouterLink } from 'react-router-dom'
import { Box, StackView } from '@planningcenter/tapestry-react'
import { Link as SharedLink, PageHeading, Text } from '../../shared/typography'
import Image from '../../shared/image'
import clearstream_example_add_on from '../../../assets/images/clearstream_example_add_on.png'

const page = () => {
  return (
    <StackView axis="vertical" spacing={2}>
      <PageHeading>Planning Center Add-ons</PageHeading>

      <Text>
        Planning Center add-ons are OAuth applications with one or more
        React-based UI components that are rendered within the web-based user
        interface of Planning Center products.
      </Text>

      <Text>
        Less technically, add-ons allow you to build features for our shared
        customers <em>inside Planning Center</em>!
      </Text>

      <Text>
        As an example, the screenshot below is the{' '}
        <Link to="https://clearstream.io/" external>
          Clearstream
        </Link>{' '}
        add-on live in Planning Center. All of the contents below the "Add-on
        support" link are controlled by Clearstream's developers.
      </Text>

      <Box>
        <Image src={clearstream_example_add_on} style={{ width: '768px' }} />
      </Box>

      <Text>
        If you're ready to build an add-on of your own, the{' '}
        <Link to="/overview/add-ons/process"> process is outlined here</Link>{' '}
        (spoiler: it starts with you reaching out to us). Or, you can keep
        working through the documentation. If you're new to add-ons, it can
        help to start with some{' '}
        <Link to="/overview/add-ons/terminology">terminology</Link>.
      </Text>
    </StackView>
  )
}

export default page

function Link({ external, ...props }) {
  return external ? (
    <SharedLink external {...props} />
  ) : (
    <ReactRouterLink component={SharedLink} {...props} />
  )
}
